/* ============
 * Product Type Transformer
 * ============
 *
 * The transformer for the productType.
 */

import Transformer from './transformer';

export default class ProductTypeTransformer extends Transformer {

  static fetch(productType) {
    return {
      id: productType.id,
      name: productType.name,
      group: productType.group,
      subGroup: productType.sub_group,
      stockable: productType.stockable,
    };
  }

  static send(productType) {
    return {
      id: productType.id,
      name: productType.name,
      group: productType.group,
      sub_group: productType.subGroup,
      stockable: productType.stockable,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/productType.js